<template>
    <v-card
            color="transparent"
            class="mx-auto pa-1"
            flat
    >
        <v-card-title primary-title>
            <profile-sub-tittle text="Calificaciones" />
        </v-card-title>

        <v-divider dark></v-divider>
        <div v-if="ratingsSummary.count == 0" class="pa-3 text-center">
            <p>Este proveedor aún no tiene calificaciones</p>
        </div>
        <v-expansion-panel v-else>
                <expansion-rating-feed
                        v-for="(item, index) in ratingsSummary.last"
                        :key="item.id || index"
                        :rating="item"
                ></expansion-rating-feed>
        </v-expansion-panel>

        <v-card-actions v-if="ratingsSummary.last.length < ratingsSummary.count">
            <v-spacer></v-spacer>
            <v-btn text>ver mas</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    import ExpansionRatingFeed from '@/components/ratings/ExpansionRatingFeed'
    import ProfileSubTittle from "@/components/providers/profile/ProfileSubTittle";
    export default{
        components: {
          ProfileSubTittle,
            ExpansionRatingFeed
        },
        props: ['ratingsSummary', 'providerId']
    }
</script>

<style scoped>
    >>>.v-expansion-panel{
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
    }
</style>
